import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { CMS, SEARCH } from '@/config'

import DefaultPageLoader from '../../main/components/DefaultPageLoader'
import SearchResultsListJobItem from '../../search/components/SearchResultsListJobItem'
import { parse } from '../../utils/locationConverter'
import { loadCmsJobs } from '../store/actions'
import {
  getCmsJobsList,
  getCmsJobsLoading,
  getCmsJobsTotalSize
} from '../store/selectors'

export const SearchResultsBlock = ({ query, landing }) => {
  const dispatch = useDispatch()

  const loading = useSelector(getCmsJobsLoading)
  const size = useSelector(getCmsJobsTotalSize)
  const items = useSelector(getCmsJobsList)
  const hasMoreResults = size > CMS.SEARCH_RESULTS_MAX_JOBS
  const hasItems = size !== null && size > 0
  const hasResponse = size !== null && size >= 0 && !loading
  const url = landing || `${SEARCH.types.job.location}?${query}`

  useEffect(() => {
    const queryParams = parse(query)
    if (!loading && !hasResponse) {
      dispatch(loadCmsJobs(queryParams))
    }
  }, [loading, hasResponse, dispatch, query])

  if (loading) {
    return <DefaultPageLoader />
  }

  return hasItems && (
    <section className='container cms-block__container cms-block__container--search-results cms-section'>
      <div className='search-results qa-search-results'>
        <div className='search-results__title'>Aktuelle Stellenangebote:</div>
        <div className='search-results__items'>
          <div className='row'>
            {items.map((item, index) => (
              <div className='col-12 col-xl-6 search-results__item qa-search-item' key={index}>
                <SearchResultsListJobItem
                  item={item}
                  target='_blank'
                />
              </div>
            ))}
          </div>
        </div>
        {hasMoreResults &&
          <div className='search-results__link qa-more-results'>
            <a
              href={url}
              target='_blank'
              rel='noopener noreferrer'
              className='qa-more-link'
            >Weitere relevante Jobs
            </a>
          </div>}
      </div>
    </section>
  )
}

SearchResultsBlock.propTypes = {
  query: PropTypes.string.isRequired,
  landing: PropTypes.string
}

export default SearchResultsBlock
